export default {
  esg_dashboard: {
    title: '仪表板',
  },
  improvement_plans: {
    title: '改进计划',
  },
  question_group_section: {
    card_title: '未答复的问卷/调查',
    list_header_buyer_company_name: '委托评估公司',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: '回答截止时间',
    list_header_status: '状态',
    number_of_answered_label: '回答数量',
    // number_of_answered_unit: '',
    number_of_answered: '完成率： {answered}/{total}',
    status_re_answer_request: '撤回请求正在进行中',
    answer: '回答',
    withdrawn: '已驳回',
    // no_survey_response_requests_text_1:  '',
    // contact: '',
    // no_survey_response_requests_text_2: '',
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: '委托评估公司',
    list_header_question: '调查表',
    list_header_create_at: '发布日',
    list_header_deadline: '有效期',
    list_header_status: '状态',
    limit_one_year: '自发布日起一年',
    esg_score: 'ESG得分',
    esg_rating: 'ESG评级',
    detail: '详细信息',
  },
  faq_section: {
    card_title: 'FAQs',
    faq_why_request: {
      question: '为什么合作方会要求进行ASUENE ESG评估？',
      answer:
        '近年来，大型企业在可持续性采购方面的举措备受关注，这些企业在开展业务时需要考虑与ESG相关的社会要求，包含供应链中的环境和人权等。在这种背景下，大型企业不仅要摸查自己公司的举措，还需要了解“自己公司的合作方是否实施了ESG举措”。',
    },
    faq_what_benefit: {
      question: '进行ASUENE ESG评估有哪些好处？',
      answer:
        '接受ASUENE ESG有以下3点好处。 \n1)可以了解贵公司在ESG方面的优势和可改进之处\n2)可以将贵公司的ESG评估结果与同行业其他公司进行对比\n3)通过公开贵公司的ESG评估结果，可以宣传贵公司为ESG做出的努力',
    },
    list: '查看一览',
  },
  contact_section: {
    card_title: '联系我们',
    description:
      '如对调查表内容或回答方式有任何疑问请随时联系我们。如希望有更具体的ESG举措改进方案、或伴随式支持，您也可以另外获得专业顾问的支持。',
    inquiry: '联系我们',
  },
}
